import React from "react";
import { DiferenciasAcopioTable } from "../../../components/DiferenciasAcopioTable";
import { SeccionReporte } from "../../../components/SeccionReporte";

// La diferencia acopio con la que se calculó la columna del comparativo. Va sin
// edición y sin la referencia de traslados: esa sirve para repartir la
// diferencia antes de cerrar, y aquí el reparto ya está hecho
export const SeccionDiferenciasRegistradas = ({ hook }) => (
    <SeccionReporte
        titulo="Diferencia acopio por periodo"
        descripcion="Diferencia registrada al cerrar el periodo, de la que sale la columna Diferencia acopio del comparativo."
    >
        <DiferenciasAcopioTable
            periodos={hook.comparativo.diferencias_acopio_por_periodo}
            mostrarReferencia={false}
        />
    </SeccionReporte>
);
